import initialState from '../../../redux/initialState';
import {isAuthenticated} from '../../../logic/authHelpers';

export const init = () => ({
  type: 'APP:INIT',
  isAuthenticated: isAuthenticated()
});

export default function appReducer(state = initialState.appState, action) {
  switch (action.type) {
    case 'REGISTRATION:VK-REQUEST-SENT-SUCCESS':
    case 'REGISTRATION:FB-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-FB-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-VK-REQUEST-SENT-SUCCESS':
    case 'SIGNIN:LOGIN-REQUEST-SENT-SUCCESS':
    case 'REGISTRATION:LOGIN-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        access_token: action.access_token,
        userId: action.userId
      };

    case 'APP:INIT':
      return {
        ...state,
        isAuthenticated: action.isAuthenticated
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/App/redux/AppActions.js
 **/